import PayrollColor from './PayrollColor';
import EmailSettings from './EmailSettings';
import { ManageAttendanceFunctionality } from '../../Functionality/ManageAttendance';
import React from 'react';
import Receivers from './Receivers';
import AttendanceCycle from './AttendanceCycle';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const ManageAttendance = (
    {
        registerAction
    }
) => {

    const {
        emptyFields,
        user, setUser,
        item,
        handleChange,
        emailItem,
        handleChangeEmail,
        cycleItem,
        handleChangeCycle,
        resetToDefaultPallet
    } = ManageAttendanceFunctionality({
        registerAction
    });

    return (
        <>
                <div className='row'>

                    <PayrollColor
                        item={item}
                        onChange={handleChange}
                        resetToDefaultPallet={resetToDefaultPallet}
                    />

                    <AttendanceCycle
                        item={cycleItem}
                        onChange={handleChangeCycle}
                        emptyFields={emptyFields}
                    />

                    <EmailSettings
                        item={emailItem}
                        onChange={handleChangeEmail}
                        emptyFields={emptyFields}
                    />

                    <Receivers
                        user={user}
                        setUser={setUser}
                    />

                </div>
        </>
    );
};

export default ManageAttendance;
